const visualsByState = {
    pending: {
        color: 'secondary',
        icon: 'ri-checkbox-blank-circle-line',
        label: 'Pending',
        stroke: '#ced4da',
    },
    processing: {
        color: 'primary',
        icon: 'ri-loader-4-line',
        label: 'Processing',
        stroke: '#556ee6',
    },
    completed: {
        color: 'success',
        icon: 'ri-checkbox-circle-fill',
        label: 'Completed',
        stroke: '#34c38f',
    },
    warning: {
        color: 'warning',
        icon: 'ri-error-warning-fill',
        label: 'Warning',
        stroke: '#f1b44c',
    },
    failed: {
        color: 'danger',
        icon: 'ri-close-circle-fill',
        label: 'Failed',
        stroke: '#f46a6a',
    },
};

export const FLOW_STATE_LEGEND = Object.keys(visualsByState);

const getStateVisuals = (state) => visualsByState[state] || visualsByState.pending;

export default getStateVisuals;
